import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { color } from 'theme';
import { StyledContainer } from '../shared/sectionChart/SectionChart.styled';

export const StyledSection = styled.div`
  ${StyledContainer} ${Heading2}::before {
    background-color: ${color('sun_500')};
  }
`;

export const StyledSelect = styled.div`
  align-self: flex-start;
  min-width: 16rem;
`;
